import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Clinic } from '@models/clinic';
import { ClinicsService } from '@services/clinics.service';
import { Editor } from 'primeng/editor';
import { Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'app-org-invoice-text-editor',
  templateUrl: './org-invoice-text-editor.component.html',
  styleUrls: ['./org-invoice-text-editor.component.less'],
})
export class OrgInvoiceTextEditorComponent implements OnInit, OnDestroy {
  loading: boolean;
  clinic: Clinic;
  invoiceText = new FormControl('');
  unsub = new Subject<any>();

  @ViewChild('editor', { static: true }) editor: Editor;

  constructor(private clinicsService: ClinicsService) {}

  ngOnInit() {
    this.clinicsService.clinicIdSelected$
      .pipe(
        takeUntil(this.unsub),
        tap(() => (this.loading = true)),
        switchMap((clinicId) => this.clinicsService.getClinicById(clinicId))
      )
      .subscribe((clinic) => {
        this.clinic = clinic;
        this.invoiceText.setValue(clinic.customInvoiceText);
        this.loading = false;
      });
  }

  onSave() {
    // Get the clinic in case it's updated
    this.loading = true;
    this.clinicsService
      .getClinicById(this.clinic.clinicId)
      .pipe(
        switchMap((clinic) => {
          clinic.customInvoiceText = this.invoiceText.value;
          return this.clinicsService.updateClinic(clinic);
        })
      )
      .subscribe(
        () => {
          this.clinic.customInvoiceText = this.invoiceText.value;
          this.clinicsService.clinicUpdated.next(this.clinic);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  onReset() {
    this.invoiceText.reset(this.clinic.customInvoiceText);
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
